function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var panelMenuMarkup = require('./panel_menu.template');
var openMenu = null;
var PanelMenu = /*#__PURE__*/function () {
  function PanelMenu() {
    _classCallCheck(this, PanelMenu);
  }
  return _createClass(PanelMenu, null, [{
    key: "markup",
    value: function markup(menuId) {
      return panelMenuMarkup(menuId);
    }

    /** Script editor panels — JSON display or interactive editing (header always visible). */
  }, {
    key: "shouldShowForScriptPanel",
    value: function shouldShowForScriptPanel() {
      return true;
    }

    /**
     * Witness/status panel — hide menu on passive guidance and summary states.
     * Menus belong on actionable JSON/editing surfaces only.
     */
  }, {
    key: "shouldShowForWitnessPanel",
    value: function shouldShowForWitnessPanel(phase) {
      var passivePhases = ['script-help', 'required-help', 'script-ready', 'required-complete'];
      return !passivePhases.includes(phase);
    }
  }, {
    key: "attach",
    value: function attach(root, _ref) {
      var menuId = _ref.menuId,
        onAction = _ref.onAction;
      if (!root) {
        return;
      }
      var menuRoot = root.querySelector("[data-rs-panel-menu=\"".concat(menuId, "\"]"));
      if (!menuRoot || menuRoot.dataset.rsPanelMenuBound === '1') {
        return;
      }
      menuRoot.dataset.rsPanelMenuBound = '1';
      var trigger = menuRoot.querySelector('.rs-panel-menu-trigger');
      var dropdown = menuRoot.querySelector('.rs-panel-menu-dropdown');
      if (!trigger || !dropdown) {
        return;
      }
      var close = function close() {
        dropdown.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (openMenu === menuRoot) {
          openMenu = null;
        }
        document.removeEventListener('click', onDocClick, true);
        document.removeEventListener('keydown', onKeyDown, true);
      };
      var onDocClick = function onDocClick(event) {
        if (!menuRoot.contains(event.target)) {
          close();
        }
      };
      var onKeyDown = function onKeyDown(event) {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      };
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = dropdown.hidden;
        if (openMenu && openMenu !== menuRoot) {
          PanelMenu.closeOpen();
        }
        if (willOpen) {
          dropdown.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          openMenu = menuRoot;
          document.addEventListener('click', onDocClick, true);
          document.addEventListener('keydown', onKeyDown, true);
        } else {
          close();
        }
      });
      dropdown.querySelectorAll('[data-action]').forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.stopPropagation();
          var action = item.dataset.action;
          close();
          if (typeof onAction === 'function') {
            onAction(action);
          }
        });
      });
    }
  }, {
    key: "closeOpen",
    value: function closeOpen() {
      if (!openMenu) {
        return;
      }
      var trigger = openMenu.querySelector('.rs-panel-menu-trigger');
      var dropdown = openMenu.querySelector('.rs-panel-menu-dropdown');
      if (dropdown) {
        dropdown.hidden = true;
      }
      trigger === null || trigger === void 0 || trigger.setAttribute('aria-expanded', 'false');
      openMenu = null;
    }
  }]);
}();
module.exports = PanelMenu;